import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AddBtn } from "@commonComponents/AddBtn";
import { FormTitle } from "@commonComponents/FormTitle";
const RepeatableContainer = (props) => {
  const {
    addItem,
    deleteItem:deleteData,
    updateItem:onChange,
    saveItem:onBlur,
    onSelect,
    maxRowsAllowed=99,
    translate,
    reducerName,
    tableName,
    renderForm,
    title,
    errorTitle,
    boxNumber,
    hideAddBtn,
    validateError,
    updateErrors,
    otherParams,
    style,
    isDisabled=null
  } = props
  const [toggleAddBtn,setToggleAddBtn]=useState(true)  
  const dataSource = useSelector((state) => state[reducerName][tableName]) || [];
  const dispatch=useDispatch()
  const validateErrors=useCallback(()=>{
    if(!validateError || !updateErrors)
         return null
    let errors=dispatch(validateError(reducerName,tableName,title||errorTitle)) || {}
    errors = Object.entries(errors)?.reduce((prev, [_, val])=>val?({...prev,[_]:val }) :({...prev}),{}) // Temp solution
    updateErrors(errors,[title||errorTitle])
  },[tableName,reducerName,title,errorTitle,updateErrors,validateError])

  if(dataSource?.length==0 &&  hideAddBtn)
      return null
  return (
  
    <div style={style}>
      <FormTitle id={tableName} title={title} boxNumber={boxNumber} />
      { (renderForm && dataSource?.length) ? renderForm({deleteData,onSelect,onChange,onBlur,dataSource,tableName,validateErrors,translate,title}) : null}
      { (dataSource?.length<maxRowsAllowed) && !hideAddBtn  && <AddBtn isDisabled={!toggleAddBtn || isDisabled}  onClick={async()=>{
        setToggleAddBtn(prev=>!prev)
        const response=await addItem(tableName,otherParams)
        validateErrors()
        setToggleAddBtn(prev=>!prev)
      }} text={translate("ADD")} />}
    
      </div>
   
  );
}

export default React.memo(RepeatableContainer)